import { Popover } from "@drone-js/core";
import { DatePicker } from "@drone-js/date";
import { format } from "date-fns";
import type { ProfileData } from "libs/codegen/property-onboarding";
import { type FunctionComponent, useState } from "react";
import type { FieldPath } from "react-hook-form";
import { DropdownTrigger } from "../form/DropdownTrigger";
import { useFormController } from "../form/useFormController";
import { useStaticDataAtomValue } from "../staticDataAtom";

type ValidPath = FieldPath<ProfileData>;

interface Props {
    fieldPrefix: string;
    dataElementName?: string;
}

export const BirthdayField: FunctionComponent<Props> = ({ fieldPrefix, dataElementName }) => {
    const {
        cmsData: {
            profile: { dateOfBirth, dateOfBirthRequired },
        },
    } = useStaticDataAtomValue();
    const { value, setValue, fieldState, ref } = useFormController<ProfileData>(
        `${fieldPrefix}.birthDate` as ValidPath,
        {
            rules: {
                required: dateOfBirthRequired,
            },
        },
    );
    const [popover, setPopover] = useState(false);

    const datePicker = (
        <DatePicker
            variant="single"
            date={undefined}
            monthYearPicker={true}
            onDateSelect={(date) => {
                setPopover(false);
                setValue(date.toISOString());
            }}
            isSingleDate={true}
        />
    );

    return (
        <Popover content={datePicker} pointerPosition="start-below" visible={popover} onVisibilityChange={setPopover}>
            <DropdownTrigger
                ref={ref}
                label={dateOfBirth}
                value={value ? format(new Date(value as string), "dd MMM yyyy") : undefined}
                error={fieldState?.error?.message}
                dataElementName={dataElementName}
            />
        </Popover>
    );
};
